import React from 'react';
import {
  FeaturesMegaMenuGetStartedContainer,
  FeaturesMegaMenuGetStartedContainerProps,
  FeaturesMegaMenuGetStartedImage,
  FeaturesMegaMenuGetStartedImages,
  FeaturesMegaMenuGetStartedImageText,
  FeaturesMegaMenuGetStartedLink,
  FeaturesMegaMenuGetStartedLinkDivider,
  FeaturesMegaMenuGetStartedLinks,
  FeaturesMegaMenuGetStartedWrapper,
  FeaturesMegaMenuGetStartedWrapperProps,
} from './FeaturesMegaMenuGetStarted.styles';
import Paragraph from 'src/elements/typography/paragraph';
import { palette } from 'src/styles/colors';
import { graphql, useStaticQuery } from 'gatsby';
import { IStaticContentfulImages } from 'src/types/contentful';
import { GatsbyImage } from 'gatsby-plugin-image';
import Heading from 'src/elements/typography/heading';
import IconsCallToActionArrow from 'src/images/IconsCallToActionArrow';

type FeaturesMegaMenuGetStartedProps = FeaturesMegaMenuGetStartedWrapperProps &
  FeaturesMegaMenuGetStartedContainerProps;

const FeaturesMegaMenuGetStarted = ({
  noBackground = false,
  isFullWidth = false,
}: FeaturesMegaMenuGetStartedProps): JSX.Element => {
  const { getBrandedApps, moveToMighty } = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      getBrandedApps: contentfulAsset(contentful_id: { eq: "5wx2ZEq7JuKkJMBC1YLPBu" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
      moveToMighty: contentfulAsset(contentful_id: { eq: "4fJ9jfZbU1tDxSURVcKw0c" }) {
        gatsbyImageData(width: 600, layout: CONSTRAINED, placeholder: BLURRED)
      }
    }
  `);

  return (
    <FeaturesMegaMenuGetStartedWrapper noBackground={noBackground}>
      <FeaturesMegaMenuGetStartedContainer isFullWidth={isFullWidth}>
        <Paragraph
          standardSize='0.75'
          letterSpacing={1}
          text='GET STARTED'
          align='left'
          weight={600}
          color={palette.darkSilver}
        />
        <FeaturesMegaMenuGetStartedImages>
          <FeaturesMegaMenuGetStartedImage>
            <GatsbyImage
              image={moveToMighty.gatsbyImageData}
              alt='move-to-mighty'
            />
            <FeaturesMegaMenuGetStartedImageText className='image-text'>
              <Heading
                standardSize='1.25'
                text={`High churn? Low engagement? It's time to move to Mighty`}
                className='image-title'
                color={palette.white}
              />
              <FeaturesMegaMenuGetStartedLink
                text='Learn More'
                url='/migration'
                colorScheme='White'
                colorSchemeVariant='tertiary'
                customBorderColor='transparent'
                standardSize='0.75'
                className='image-link'
                icon={
                  <IconsCallToActionArrow
                    color='white'
                    width={14}
                  />
                }
              />
            </FeaturesMegaMenuGetStartedImageText>
          </FeaturesMegaMenuGetStartedImage>
          <FeaturesMegaMenuGetStartedImage>
            <GatsbyImage
              image={getBrandedApps.gatsbyImageData}
              alt='get-branded-apps'
            />
            <FeaturesMegaMenuGetStartedImageText className='image-text'>
              <Heading
                standardSize='1.25'
                text='Get your own branded apps on Mighty Pro'
                className='image-title'
                color={palette.white}
              />
              <FeaturesMegaMenuGetStartedLink
                text='Learn More'
                url='/pro'
                colorScheme='White'
                colorSchemeVariant='tertiary'
                customBorderColor='transparent'
                standardSize='0.75'
                className='image-link'
                icon={
                  <IconsCallToActionArrow
                    color='white'
                    width={14}
                  />
                }
              />
            </FeaturesMegaMenuGetStartedImageText>
          </FeaturesMegaMenuGetStartedImage>
        </FeaturesMegaMenuGetStartedImages>
        <FeaturesMegaMenuGetStartedLinks>
          <FeaturesMegaMenuGetStartedLink
            text='View Plans'
            url='/pricing'
            colorScheme='Black'
            colorSchemeVariant='tertiary'
            customBorderColor='transparent'
            standardSize='1'
          />
          <FeaturesMegaMenuGetStartedLinkDivider />
          <FeaturesMegaMenuGetStartedLink
            text='Reviews'
            url='/reviews'
            colorScheme='Black'
            colorSchemeVariant='tertiary'
            customBorderColor='transparent'
            standardSize='1'
          />
        </FeaturesMegaMenuGetStartedLinks>
      </FeaturesMegaMenuGetStartedContainer>
    </FeaturesMegaMenuGetStartedWrapper>
  );
};

export default FeaturesMegaMenuGetStarted;
